import {Injectable} from '@angular/core'
import {ServiceProviderHub} from "@generated-backend-types";
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import TableFilterFavorite = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Meta.TableFilterFavorite;
import TableFilterFavoriteData = ServiceProviderHub.App.Data.ServiceProviderHub.Settings.TableFilterFavoriteData;

@Injectable({
  providedIn: 'root'
})
export class TableFilterFavoritesService extends BaseApiEndpointService<TableFilterFavorite, TableFilterFavoriteData> {
  protected override endpoint = '/settings/table-filter-favorites'

  public override modelToMultiSelectItem(m: TableFilterFavorite): ListItem & { model: TableFilterFavorite; } {
    return {
      id: m.id,
      text: m.title,
      isDisabled: false,
      model: m,
    }
  }
}
